module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_plan_show_bg_02-a5eddb184e2baeebad07a328b78b5d23.jpg";